module.exports = {
    "type": "FeatureCollection",
    "features": [
      {
        "type": "Feature",
        "properties": {
          "Hill": "Aventine Hill",
          "LAT": 41.883754,
          "LONG": 12.483022
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            12.483022,
            41.883754
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "Hill": "Palatine Hill",
          "LAT": 41.891006,
          "LONG": 12.486176
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            12.486176,
            41.891006
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "Hill": "Capitoline Hill",
          "LAT": 41.89414,
          "LONG": 12.483344
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            12.483344,
            41.89414
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "Hill": "Caelian Hill",
          "LAT": 41.883397,
          "LONG": 12.49535
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            12.49535,
            41.883397
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "Hill": "Esquiline Hill",
          "LAT": 41.894882,
          "LONG": 12.499673
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            12.499673,
            41.894882
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "Hill": "Viminal Hill",
          "LAT": 41.899319,
          "LONG": 12.493536
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            12.493536,
            41.899319
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "Hill": "Quirinal Hill",
          "LAT": 41.899088,
          "LONG": 12.486645
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            12.486645,
            41.899088
          ]
        }
      }
    ]
  }
;